// All content for the Blanktjern Coaching site, with NO (Norwegian) and EN (English) translations.

export const CALENDLY_URL = "https://calendly.com/frode-blanktjern/30min"; // legacy fallback
export const BOOK_PATH = "/book";
export const INSTAGRAM_URL = "https://www.instagram.com/blanktjerncoaching";
export const YOUTUBE_URL = "https://www.youtube.com/@blanktjerncoaching2601";

export const HERO = {
  slogan: { no: "God. Men enda bedre.", en: "Don't be good. Be great." },
  headline: {
    no: "Ta treningen din til neste nivå med en personlig coach",
    en: "Take your training to the next level with a personal coach",
  },
  sub: {
    no: "Blanktjern Coachings unike tilnærming til trening har siden 2017 hjulpet over 750 utøvere innen sykkel, løp, triathlon og langrenn. Uansett nivå. Uansett mål. Er du neste?",
    en: "Blanktjern Coaching's unique approach to training has helped over 750 athletes in cycling, running, triathlon and cross-country skiing since 2017. Any level. Any goal. Are you next?",
  },
  bullets: [
    { id: "plan", no: "Individuell treningsplan tilpasset ditt liv", en: "Individual training plan adapted to your life" },
    { id: "follow-up", no: "Personlig oppfølging fra erfarne trenere", en: "Personal follow-up from experienced coaches" },
    { id: "levels", no: "Utøvere på alle nivå, fra mosjonist til elite", en: "Athletes at all levels, from recreational to elite" },
  ],
};

export const TESTIMONIALS_1 = [
  {
    id: "tiril-jorgensen",
    img: "/images/img_2.jpg",
    name: "Tiril Jørgensen",
    age: 25,
    sport: { no: "Sykkel", en: "Cycling" },
    quote: {
      no: "Jeg har hatt samme trener i snart 8 år. Gjennom tett oppfølging og stor faglig kompetanse har han hjulpet meg til å bli syklisten jeg er i dag. I år signerte jeg for et pro-continental-lag, vant Birken 2025, og tok topp-10 i flere internasjonale etapperitt.",
      en: "I've had the same coach for almost 8 years. Through close follow-up and great expertise he's helped me become the cyclist I am today. This year I signed for a pro-continental team, won Birken 2025, and finished top-10 in several international stage races.",
    },
  },
  {
    id: "ketil-johnsen",
    img: "/images/img_19.jpg",
    name: "Ketil Johnsen",
    age: 63,
    sport: { no: "Sykkel", en: "Cycling" },
    quote: {
      no: "Jeg har brukt Blanktjern siden 2019. De lager en langsiktig plan og tilpasser opplegget etter resultatene. Fremgangen kommer fordi man trener systematisk over tid med fokus på det som faktisk virker.",
      en: "I've used Blanktjern since 2019. They build a long-term plan and adapt the program based on results. Progress comes from training systematically over time with focus on what actually works.",
    },
  },
  {
    id: "simen-haugland",
    img: "/images/img_4.jpg",
    name: "Simen Haugland",
    age: 29,
    sport: { no: "Løp", en: "Running" },
    quote: {
      no: "Da jeg bestemte meg for å løpe mitt første maraton visste jeg at jeg trengte en plan som matcher ambisjonene mine. Med Blanktjern har jeg fått en struktur der hver økt har en tydelig hensikt. Progresjonen siden oppstart har vært enorm.",
      en: "When I decided to run my first marathon I knew I needed a plan that matched my ambitions. With Blanktjern I got a structure where every session has a clear purpose. The progress since we started has been enormous.",
    },
  },
];

export const TESTIMONIALS_2 = [
  {
    id: "kamil-kulik",
    img: "/images/img_3.jpg",
    name: "Kamil Kulik",
    age: 23,
    sport: { no: "Triathlon", en: "Triathlon" },
    quote: {
      no: "Vi finner den perfekte balansen med trening tilpasset meg. Sammenlignet med i fjor svømmer jeg raskere og presterer mye bedre i konkurranser. Jeg kvalifiserte meg til EM og fokuserer nå på å kvalifisere meg til U23 VM.",
      en: "We're finding the perfect balance with training adapted to me. Compared to last year I'm swimming faster and performing much better in races. I've qualified for the European Championships and my focus is now on qualifying for the U23 World Championships.",
    },
  },
  {
    id: "sturla-langorgen",
    img: "/images/img_5.jpg",
    name: "Sturla Langørgen",
    age: 56,
    sport: { no: "Langrenn", en: "XC Skiing" },
    quote: {
      no: "Endelig Nattvasan under 5 timer. Målrettet treningsprogram tilpasset meg. Riktig trening hjelper.",
      en: "Finally Nattvasan under 5 hours. A targeted training program adapted to me. The right training makes the difference.",
    },
  },
  {
    id: "norman-rahmel",
    img: "/images/img_6.jpg",
    name: "Norman Rahmel",
    age: 27,
    sport: { no: "Triathlon", en: "Triathlon" },
    quote: {
      no: "Mitt mål er å kvalifisere meg til Ironman VM i Kona. Jeg valgte Blanktjern fordi nordmenn er i front innen utholdenhetsidrett. Måten de kontrollerer intensitet på er nøkkelen til utvikling. Et perfekt match.",
      en: "My goal is to qualify for the Ironman World Championship in Kona. I chose Blanktjern because the Norwegians are at the cutting edge of endurance sport. The way they control intensity is the key to development. A perfect match.",
    },
  },
  {
    id: "stine-hafner",
    img: "/images/img_7.jpg",
    name: "Stine Häfner",
    age: 23,
    sport: { no: "Triathlon", en: "Triathlon" },
    quote: {
      no: "Trenger du hjelp til å strukturere treninga di frem mot konkurranse og ønsker et solid team med mye kunnskap i ryggen, burde du absolutt velge Blanktjern Coaching!",
      en: "If you need help structuring your training towards competition and want a solid team with a lot of knowledge behind you, you should absolutely choose Blanktjern Coaching!",
    },
  },
  {
    id: "eira-thorsteinsen",
    img: "/images/img_17.jpg",
    name: "Eira Thorsteinsen",
    age: 27,
    sport: { no: "Triathlon", en: "Triathlon" },
    quote: {
      no: "Jeg velger coaching fra Blanktjern for å kunne trene med best mulig kvalitet og få mest ut av treningen når tid er den begrensende faktoren.",
      en: "I choose Blanktjern Coaching to train with the best possible quality and get the most out of my training when time is the limiting factor.",
    },
  },
  {
    id: "havard-gjeldnes",
    img: "/images/img_18.jpg",
    name: "Håvard Gjeldnes",
    age: 35,
    sport: { no: "Sykkel", en: "Cycling" },
    quote: {
      no: "Jeg slipper å bruke tid og energi på å planlegge treningen. Oppfølgingen er det som virkelig skiller seg ut - hver økt blir analysert og tilbakemeldingene er konstruktive og motiverende. Resultatet er mindre stress og mer energi til det som betyr noe: å gjennomføre dagens økt så godt som mulig.",
      en: "I don't have to spend time and energy planning my training. The follow-up is what really stands out - every session is analysed and the feedback is constructive and motivating. The result is less stress and more energy for what matters: performing as well as possible in today's session.",
    },
  },
];

export const STEPS = [
  {
    id: "step-01",
    num: "01",
    title: { no: "Book en gratis samtale", en: "Book a free call" },
    desc: {
      no: "Vi blir kjent med deg, dine mål og din hverdag. Ingen forpliktelser.",
      en: "We get to know you, your goals and your everyday life. No obligations.",
    },
  },
  {
    id: "step-02",
    num: "02",
    title: { no: "Få din personlige plan", en: "Get your personal plan" },
    desc: {
      no: "Din coach lager et treningsprogram tilpasset ditt nivå, din idrett og ditt liv. Planen leveres i TrainingPeaks, som du også får tilgang til som app på telefonen.",
      en: "Your coach creates a training program tailored to your level, sport and life. The plan is delivered in TrainingPeaks, which you also access as an app on your phone.",
    },
  },
  {
    id: "step-03",
    num: "03",
    title: { no: "Tren med oppfølging", en: "Train with follow-up" },
    desc: {
      no: "Du trener. Vi følger opp, justerer og sørger for at du utvikler deg uke for uke.",
      en: "You train. We follow up, adjust and make sure you develop week by week.",
    },
  },
];

export const TP_COPY = {
  no: "Slik ser det ut i appen. Din coach legger inn planen, og du har alt tilgjengelig rett i lomma.",
  en: "This is what it looks like in the app. Your coach enters the plan, and you have everything available right in your pocket.",
};

export const FIT_LIST = [
  { id: "fit-1", no: "Trener mot et konkret mål, men mangler en tydelig plan", en: "Training towards a goal, but lacking a clear plan" },
  { id: "fit-2", no: "Ønsker personlig oppfølging fra en erfaren coach", en: "Want personal follow-up from an experienced coach" },
  { id: "fit-3", no: "Driver med triatlon, sykkel, løp eller langrenn", en: "Into triathlon, cycling, running or cross-country skiing" },
  { id: "fit-4", no: "Vil bli bedre, uansett om du er mosjonist eller satser mot toppen", en: "Want to improve, whether recreational or aiming for the top" },
  { id: "fit-5", no: "Trener jevnt, men føler du ikke får den utviklingen du fortjener", en: "Training consistently, but not getting the progress you deserve" },
  { id: "fit-6", no: "Ønsker bedre balanse mellom trening og hverdagsliv", en: "Looking for better balance between training and everyday life" },
];

export const TEAM = [
  {
    id: "frode-viberg-jermstad",
    img: "/images/img_9.jpg",
    name: "Frode Viberg Jermstad",
    calendly: "https://calendly.com/frode-blanktjern/30min",
    role: { no: "Grunnlegger & Coach", en: "Founder & Coach" },
    bio: {
      no: "Utdannet toppidrettstrener fra Norges Idrettshøgskole. Tidligere landslagsutøver i langrenn og kombinert. I dag en av Norges beste triatleter i sin aldersklasse. Sportssjef i Norges Triatlonforbund.",
      en: "Educated elite sports coach from the Norwegian School of Sport Sciences. Former national team athlete in XC skiing and nordic combined. Currently one of Norway's best triathletes in his age group. Sports Director at the Norwegian Triathlon Federation.",
    },
  },
  {
    id: "sindre-skjostad-lunke",
    img: "/images/img_10.jpg",
    name: "Sindre Skjøstad Lunke",
    calendly: "https://calendly.com/sindre-lunke/30min",
    role: { no: "Sykkelcoach", en: "Cycling Coach" },
    bio: {
      no: "Tidligere proffsyklist for Team Giant-Alpecin/Sunweb. Syklet Giro d'Italia og Vuelta a España. Del av vinnerlaget i Giro d'Italia 2017.",
      en: "Former pro cyclist for Team Giant-Alpecin/Sunweb. Raced the Giro d'Italia and Vuelta a España. Part of the winning team in Giro d'Italia 2017.",
    },
  },
  {
    id: "espen-bjornstad",
    img: "/images/img_11.jpg",
    name: "Espen Bjørnstad",
    calendly: "https://calendly.com/ebjoernstad/30min",
    role: { no: "Langrenn & Løpecoach", en: "XC Skiing & Running Coach" },
    bio: {
      no: "Olympisk mester, 2x Verdensmester og 2x Norgesmester i kombinert. Nyeste medlem i teamet med erfaring fra idrettens aller høyeste nivå.",
      en: "Olympic champion, 2x World Champion and 2x Norwegian Champion in nordic combined. Newest team member with experience from the very top of elite sports.",
    },
  },
  {
    id: "sebastian-wernersen",
    img: "/images/img_12.jpg",
    name: "Sebastian Wernersen",
    calendly: "https://calendly.com/sebastianwernersen/30min",
    role: { no: "Triatlon & Sykkelcoach", en: "Triathlon & Cycling Coach" },
    bio: {
      no: "På det norske triatlonlandslaget siden 2019. U23 Europamester 2025. Bronsemedalje i eliteklassen.",
      en: "On the Norwegian national triathlon team since 2019. U23 European Champion 2025. Bronze medal in the elite class.",
    },
  },
  {
    id: "knut-skovereng",
    img: "/images/img_13.jpg",
    name: "Knut Skovereng",
    calendly: null,
    role: { no: "Testansvarlig & Coach", en: "Head of Testing & Coach" },
    bio: {
      no: "Doktorgrad i treningsfysiologi og biomekanikk. Forsker ved Senter for Toppidrettsforskning. Prosjektleder ved Olympiatoppen Midt-Norge.",
      en: "PhD in exercise physiology and biomechanics. Researcher at the Centre for Elite Sports Research. Project Manager at Olympiatoppen Midt-Norge.",
    },
  },
  {
    id: "ole-bernard-fuskevag",
    img: "/images/img_14.jpg",
    name: "Ole Bernard Fuskevåg",
    calendly: "https://calendly.com/olebfusk/30min",
    role: { no: "Triatloncoach", en: "Triathlon Coach" },
    bio: {
      no: "Hardtsatsende triatlet, proff siden 2024. Sterk svømmebakgrunn. Tilbyr 1-til-1 svømmeopplæring i tillegg til helhetlig coaching.",
      en: "Dedicated triathlete, pro since 2024. Strong swimming background. Offers 1-on-1 swim coaching alongside full triathlon coaching.",
    },
  },
  {
    id: "lilli-ofstad",
    img: "/images/img_15.jpg",
    name: "Lilli Ofstad",
    calendly: null,
    role: { no: "Løp & Langrennscoach", en: "Running & XC Skiing Coach" },
    bio: {
      no: "Master i idrettsvitenskap fra NTNU. 15 års erfaring som trener. Spesialist på terrengløp, ultra og langrenn.",
      en: "Master's in sports science from NTNU. 15 years of coaching experience. Specialist in trail running, ultra and cross-country skiing.",
    },
  },
  {
    id: "sindre-eid-hermansen",
    img: "/images/img_16.jpg",
    name: "Sindre Eid Hermansen",
    calendly: "https://calendly.com/sindreeh",
    role: { no: "Sykkel & Triatloncoach", en: "Cycling & Triathlon Coach" },
    bio: {
      no: "Tidligere landeveissyklist på continentalnivå. Olympiatoppens høyeste trenerutdanning (Topptrener 2). Studerer fysioterapi ved NTNU.",
      en: "Former continental-level road cyclist. Holds Olympiatoppen's highest coaching certification (Topptrener 2). Studying physiotherapy at NTNU.",
    },
  },
];

export const FAQ_ITEMS = [
  {
    id: "faq-1",
    q: { no: "Hva koster coaching?", en: "What does coaching cost?" },
    a: {
      no: "Vi tilpasser opplegget etter dine behov. Book en gratis samtale så finner vi ut hva som passer for deg.",
      en: "We tailor the program to your needs. Book a free call and we'll figure out what works for you.",
    },
  },
  {
    id: "faq-2",
    q: { no: "Hvilke idretter dekker dere?", en: "Which sports do you cover?" },
    a: {
      no: "Triatlon, sykkel, løp og langrenn. Flere av våre coacher har bakgrunn fra toppidrett i nettopp din idrett.",
      en: "Triathlon, cycling, running and cross-country skiing. Several of our coaches have backgrounds from elite sports in your discipline.",
    },
  },
  {
    id: "faq-3",
    q: { no: "Trenger jeg å bo i Trondheim?", en: "Do I need to live in Trondheim?" },
    a: {
      no: "Nei. Alt foregår digitalt. Du får treningsplanen i TrainingPeaks og oppfølging fra coachen din uansett hvor du bor. Men vi tilbyr også personlig oppfølging for de som ønsker det, hovedsakelig i Trondheim.",
      en: "No. Everything is digital. You get your training plan in TrainingPeaks and follow-up from your coach wherever you live. We also offer in-person coaching for those who want it, mainly in Trondheim.",
    },
  },
  {
    id: "faq-4",
    q: { no: "Hva om jeg er nybegynner?", en: "What if I'm a beginner?" },
    a: {
      no: "Vi har utøvere på alle nivå. Fra mosjonister som trener for gøy, til folk som satser mot toppen. Planen tilpasses deg.",
      en: "We have athletes at all levels. From recreational athletes training for fun, to those aiming for the top. The plan is adapted to you.",
    },
  },
  {
    id: "faq-5",
    q: { no: "Hvordan fungerer oppfølgingen?", en: "How does the follow-up work?" },
    a: {
      no: "Du og coachen din har jevnlig kontakt. Planen justeres basert på hvordan treningen går, formen din og livet rundt.",
      en: "You and your coach have regular contact. The plan is adjusted based on how training is going, your form and life around it.",
    },
  },
];

export const STRINGS = {
  bookCallShort: { no: "Book samtale", en: "Book a call" },
  bookCallFree: { no: "Book en gratis samtale", en: "Book a free call" },
  athletesLabel: { no: "Utøvere", en: "Athletes" },
  athletesTitle: { no: "Hør fra våre utøvere", en: "Hear from our athletes" },
  processLabel: { no: "Prosess", en: "Process" },
  processTitle: { no: "Slik kommer du i gang", en: "How to get started" },
  fitTitle: { no: "Er dette deg?", en: "Is this you?" },
  coachesLabel: { no: "Trenerne", en: "The Coaches" },
  coachesTitle: { no: "Møt teamet", en: "Meet the team" },
  coachesSub: {
    no: "Vårt trenerteam har lang erfaring fra idretten og høy faglig kompetanse. Her er folkene som følger deg opp.",
    en: "Our coaching team has extensive experience from competitive sports and high-level expertise. These are the people who will follow you up.",
  },
  resultsLabel: { no: "Resultater", en: "Results" },
  resultsTitle: { no: "Utøvere som har tatt steget", en: "Athletes who took the step" },
  faqLabel: { no: "Spørsmål", en: "Questions" },
  faqTitle: { no: "Ofte stilte spørsmål", en: "Frequently asked questions" },
  ytBadgeLink: { no: "Sjekk ut YouTube-kanalen vår", en: "Check out our YouTube channel" },
  ytBadgeSuffix: {
    no: "der vi deler utøverhistorier, treningsøkter og tips.",
    en: "where we share athlete stories, training sessions and tips.",
  },
  finalText: {
    no: "Klar for å ta steget? Book en gratis og uforpliktende samtale med oss. Vi finner ut hva du trenger, og om vi er rett match for deg.",
    en: "Ready to take the step? Book a free, no-obligation conversation with us. We'll figure out what you need, and whether we're the right match for you.",
  },
  finalSlogan: { no: "God. Men enda bedre.", en: "Don't be good. Be great." },
  sykkel: { no: "Sykkel", en: "Cycling" },
  trainingPeaks: "TrainingPeaks",
  bookPageTitle: { no: "Velg din coach", en: "Choose your coach" },
  bookPageSub: {
    no: "Velg coachen du vil ta en gratis og uforpliktende samtale med. Vi finner ut sammen hva du trenger, og om vi er rett match for deg.",
    en: "Pick the coach you'd like a free, no-obligation chat with. We'll figure out together what you need, and whether we're the right match for you.",
  },
  bookThisCoach: { no: "Book samtale", en: "Book a call" },
  bookUnavailable: { no: "Kommer snart", en: "Coming soon" },
  backToHome: { no: "Tilbake til forsiden", en: "Back to home" },
};
